'use client';

import { useQuery } from '@tanstack/react-query';

import { unwrapLambdaResponse } from '@/lib/api';
import { useAccessToken, useAuth } from '@/lib/auth-client';
import { BACKEND_URL } from '@/lib/constants';

export interface OrgSelf {
  id: string;
  name: string;
  logoUrl: string | null;
  seatLimit: number;
  seatsUsed: number;
  trialEndsAt: string | null;
  currentUserRole: string;
}

export function useOrgSelf() {
  const { user, loading: authLoading } = useAuth();
  const { getAccessToken } = useAccessToken();
  return useQuery({
    queryKey: ['organization', 'self'],
    enabled: !authLoading && !!user,
    queryFn: async () => {
      const token = await getAccessToken();
      if (!token) throw new Error('Not authenticated');
      const res = await fetch(`${BACKEND_URL}/organizations/self`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error(`org fetch failed: ${res.status}`);
      return unwrapLambdaResponse<OrgSelf>(await res.json());
    },
  });
}
